module.exports = __webpack_public_path__ + "static/media/records_dataroom_icon.cafd0b99.png";